import { useInfiniteQuery, useQuery, useQueryClient } from 'react-query'
import { useRouter } from 'next/router'
import { getProjectsInProgressService, getPendingProjectsService } from 'services/projects'
import useSession from './session'

function useProjectParams(params) {
  const { query } = useRouter()
  const { token } = useSession()
  const search = query.search || params?.search || null
  const level = query.level || params?.level || null
  const property = query.property || params?.property || null
  const type = query.type || params?.type || null
  const filter = query.filter || params?.filter || null

  return [search, level, property, type, filter, token]
}

export function useProjectsInProgress(params) {
  const queryClient = useQueryClient()
  const projectParams = useProjectParams(params)
  const [search, level, property, type, filter, token] = projectParams
  return useQuery(
    ['PROJECTS_IN_PROGRESS', ...projectParams],
    () => getProjectsInProgressService({
      search, level, property, type, filter, token,
    }),
    {
      enabled: !!token,
      initialData: () => (
        queryClient.getQueryData(['PROJECTS_IN_PROGRESS', null, null, null, null, null, ''])
      ),
    },
  )
}

export async function prefetchPendingProjects({ queryClient }) {
  const projectParams = [null, null, null, null, null, '']
  await queryClient.prefetchQuery(
    ['PENDING_PROJECTS', ...projectParams],
    () => getPendingProjectsService({ token: '' }),
    {},
  )
}

export function usePendingProjects(params) {
  const queryClient = useQueryClient()
  const projectParams = useProjectParams(params)
  const [search, level, property, type, filter, token] = projectParams
  return useInfiniteQuery(
    ['PENDING_PROJECTS', ...projectParams],
    ({ pageParam }) => getPendingProjectsService({
      search, level, property, type, filter, token, page: pageParam,
    }),
    {
      getNextPageParam: ({ next }) => next?.slice(next?.indexOf('page=') + 5),
      getPreviousPageParam: ({ previous }) => previous?.slice(previous?.indexOf('page=') + 5),
      initialData: () => {
        const queryCacheData = queryClient.getQueryData(['PENDING_PROJECTS', null, null, null, null, null, ''])
        if (queryCacheData) {
          return {
            pageParams: [undefined, '2'],
            pages: [queryCacheData],
          }
        }
      },
    },
  )
}
